import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { Eyebrow } from "../components/Flow";

const PROJECTS = [
  {
    title: "RESIDENTIAL DEVELOPMENT",
    subtitle: "120-unit Caribbean residential project",
    img: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1400&q=70",
    scope: ["Ceramics, porcelain and flooring packages", "Bathroom sets: sanitaryware, faucets, furniture", "Doors, windows and aluminium systems", "Kitchens and interior lighting", "Consolidated export and delivery coordination"],
    testid: "project-residential-card",
  },
  {
    title: "HOTEL PROJECT",
    subtitle: "80-room Caribbean boutique hotel",
    img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1400&q=70",
    scope: ["Guest room and bathroom packages", "Contract furniture and lighting", "Restaurant, bar and common-area finishes", "Pool and outdoor furniture", "Phased procurement aligned with construction schedule"],
    testid: "project-hotel-card",
  },
  {
    title: "LUXURY VILLA DEVELOPMENT",
    subtitle: "Premium Caribbean villa development",
    img: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1400&q=70",
    scope: ["Premium stone, porcelain and wall finishes", "Custom kitchens and bathroom collections", "Architectural openings and glass systems", "Outdoor living: pergolas, pool products, furniture", "White-glove specification and sourcing support"],
    testid: "project-villa-card",
  },
];

export default function Projects() {
  return (
    <main data-testid="projects-page">
      <section className="bg-[#0B132B] py-20 text-white sm:py-24 grain-overlay relative">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <Eyebrow dark>Projects</Eyebrow>
            <h1 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl" data-testid="projects-headline">
              What a BUY CARIBBEAN project can look like.
            </h1>
            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/65 sm:text-base">
              Three concept examples showing how we would structure sourcing, procurement and logistics for typical Caribbean developments.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-3">
            {PROJECTS.map((p, i) => (
              <Reveal key={p.title} delay={i * 120}>
                <article className="card-lift flex h-full flex-col border border-[#0B132B]/12 bg-white" data-testid={p.testid}>
                  <div className="img-zoom relative">
                    <img src={p.img} alt={p.subtitle} className="aspect-[16/10] w-full object-cover" />
                    <span className="absolute left-4 top-4 bg-[#0B132B]/90 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-white backdrop-blur">
                      Concept Example
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <h2 className="font-display text-lg font-bold tracking-wide">{p.title}</h2>
                    <p className="mt-1.5 text-sm text-[#0B132B]/60">{p.subtitle}</p>
                    <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-[#0D9488]">
                      What we could supply &amp; coordinate
                    </p>
                    <ul className="mt-3 space-y-2.5">
                      {p.scope.map((s) => (
                        <li key={s} className="flex items-start gap-2.5 text-[13px] leading-relaxed text-[#0B132B]/75">
                          <span className="mt-1.5 h-1.5 w-1.5 shrink-0 bg-[#D97706]" />
                          {s}
                        </li>
                      ))}
                    </ul>
                    <Link to="/contact" data-testid={`${p.testid}-cta`} className="mt-auto inline-flex items-center gap-2 pt-7 text-sm font-bold text-[#0D9488] transition-colors hover:text-[#0B132B]">
                      DISCUSS A SIMILAR PROJECT <ArrowRight className="h-4 w-4" />
                    </Link>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12">
            <p className="text-center text-xs text-[#0B132B]/45" data-testid="projects-disclaimer">
              Concept examples for illustration only — they do not represent real client projects.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
